import { render, staticRenderFns } from "./EditableWikiTextArea.vue?vue&type=template&id=75075e9c&scoped=true"
import script from "./EditableWikiTextArea.vue?vue&type=script&lang=js"
export * from "./EditableWikiTextArea.vue?vue&type=script&lang=js"
import style0 from "./EditableWikiTextArea.vue?vue&type=style&index=0&id=75075e9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75075e9c",
  null
  
)

export default component.exports